import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { change, Field, formValueSelector } from 'redux-form'
import { Select } from '../../../../../../../../../itrust_common/components/form'
import { versantLenDesignLoad, versantRegisteredLabsLoad } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/versant/versantAction'
import { getLenDesignLensType, getLenDesignRangeIds, mapLenDesignRows, mapRegisteredLabToOption } from '../versantClaimHelper'

const selector = formValueSelector('VersantClaimForm')
const req = (label) => <>{label} <span className="text-danger">*</span></>
const PREFIX = 'spectacle_lens.len_information'
const DESIGN = `${PREFIX}.lens_design`

const JOB_TYPE_OPTIONS = [
  { name: 'Uncut', value: 'Uncut' },
  { name: 'Dress - Frame To Come', value: 'Dress - Frame To Come' },
  { name: 'Lens Only With Trace', value: 'Lens Only With Trace' },
  { name: 'Lens Only No Trace', value: 'Lens Only No Trace' },
]

const SINGLE_LENS_TYPE = [{ name: 'Single', value: 'Single' }]
const MULTIFOCAL_LENS_TYPES = [
  { name: 'Bi Focal', value: 'Bi Focal' },
  { name: 'Tri Focal', value: 'Tri Focal' },
  { name: 'Progressive', value: 'Progressive' },
]

const filled = (value) => value !== undefined && value !== null && String(value).trim() !== ''

function getLensTypeOptions(prescriptions = {}) {
  const hasMultifocal = ['right', 'left'].some((side) => (
    filled(prescriptions[`${side}_cyclinder`]) &&
    filled(prescriptions[`${side}_axis`]) &&
    filled(prescriptions[`${side}_addition`])
  ))

  const hasSingle = ['right', 'left'].some((side) => (
    filled(prescriptions[`${side}_sphere`]) &&
    !filled(prescriptions[`${side}_cyclinder`]) &&
    !filled(prescriptions[`${side}_axis`]) &&
    !filled(prescriptions[`${side}_addition`])
  ))

  if (hasMultifocal) return MULTIFOCAL_LENS_TYPES
  if (hasSingle) return SINGLE_LENS_TYPE
  return []
}

function VersantLabLensFields({
  claimId,
  officeApplicationUID,
  otherDetails,
  registeredLabs,
  lenDesign,
  saving,
  prescriptions,
  lenType,
  selectedDesignId,
}) {
  const dispatch = useDispatch()
  const rows = mapLenDesignRows(lenDesign)

  useEffect(() => {
    if (!claimId || !officeApplicationUID) return

    dispatch(versantRegisteredLabsLoad(claimId, {
      OfficeApplicationUId: officeApplicationUID,
      office_application_uid: officeApplicationUID,
    }))
  }, [claimId, officeApplicationUID, dispatch])

  useEffect(() => {
    if (!claimId || !lenType) return

    const member = otherDetails?.member || {}

    dispatch(versantLenDesignLoad(claimId, {
      lens_type: getLenDesignLensType(lenType),
      procedure_codes: otherDetails?.procedureCodes || [],
      range_ids: getLenDesignRangeIds(lenType),
      ignore_benefits: false,
      safety_package: false,
      medicaid_member: false,
      medicaid_buy_up: false,
      pvt_label: [],
      group_number: '',
      plan_name: 'MEMBER',
      liability_package: '',
      source_system: member.sourceSystem || '',
      usage_type: otherDetails?.usageType || '',
    }))
  }, [claimId, lenType, otherDetails, dispatch])

  const handleSelectRow = (row) => {
    dispatch(change('VersantClaimForm', `${DESIGN}.lens_material_name`, row.lensMaterial))
    dispatch(change('VersantClaimForm', `${DESIGN}.lens_design`, row.lensDesign))
    dispatch(change('VersantClaimForm', `${DESIGN}.base`, row.lensTier))
    dispatch(change('VersantClaimForm', `${PREFIX}.design_material_id`, row.id))
  }

  const laboratoryOptions = (registeredLabs || []).map(mapRegisteredLabToOption)

  return (
    <div className="border rounded p-5 mb-6">
      <h6 className="mb-5">Lab/Lens Information</h6>
      <div className="row">
        <div className="col-4">
          <Field
            name={`${PREFIX}.lab`}
            component={Select}
            label={req('Laboratory-Acct#')}
            data={laboratoryOptions}
            textField="name"
            valueField="value"
            placeholder="Select One"
            wrapperClasses="form-group"
          />
          <Field name={`${PREFIX}.len_type`} component={Select} label={req('Lens Type')} data={getLensTypeOptions(prescriptions)} textField="name" valueField="value" placeholder="Select One" wrapperClasses="form-group" />
          <Field name={`${PREFIX}.job_type`} component={Select} label={req('Job Type')} data={JOB_TYPE_OPTIONS} textField="name" valueField="value" placeholder="Select One" wrapperClasses="form-group" />
        </div>
        <div className="col-8">
          <label className="mb-3 d-block">Filter Lens Design Materials</label>
          <div className="table-responsive border rounded">
            <table className="table mb-0">
              <thead>
                <tr>
                  <th>{req('Lens Material')}</th>
                  <th>{req('Lens Design')}</th>
                  <th>{req('Lens Tier')}</th>
                </tr>
              </thead>
              <tbody>
                {saving && <tr><td colSpan="3" className="text-muted">Loading...</td></tr>}
                {!saving && rows.length === 0 && <tr><td colSpan="3" className="text-muted">No records</td></tr>}
                {!saving && rows.map((row) => (
                  <tr
                    key={row.id}
                    className={selectedDesignId === row.id ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelectRow(row)}
                  >
                    <td>{row.lensMaterial}</td>
                    <td>{row.lensDesign}</td>
                    <td>{row.lensTier}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect((state) => ({
  claimId: state.visionInsuranceClaimForm.visionInsuranceClaimForm?.id,
  officeApplicationUID: state.visionInsuranceClaimForm.visionInsuranceClaimForm?.other_details?.office?.officeApplicationUID,
  otherDetails: state.visionInsuranceClaimForm.visionInsuranceClaimForm?.other_details,
  registeredLabs: state.versantVisionInsurance.registered_labs,
  lenDesign: state.versantVisionInsurance.len_design,
  saving: state.versantVisionInsurance.saving,
  prescriptions: selector(state, 'spectacle_lens.perscriptions') || {},
  lenType: selector(state, `${PREFIX}.len_type`),
  selectedDesignId: selector(state, `${PREFIX}.design_material_id`),
}))(VersantLabLensFields)
